export default __webpack_public_path__ + "static/media/code.9c9a92d4.svg";